import { defineMessages } from 'react-intl';

export default defineMessages({
  upgradeButton: {
    id: 'view.header.UpgradeButton',
    defaultMessage: 'Upgrade',
  },
});
